import { actionTypes } from "./feedbackTypes";

const initialState: feedbackStateType = {
  sentSuccess: false
};

type feedbackStateType = {
  sentSuccess: boolean
};

const feedbackReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case actionTypes.SET_SUCCESS://TODO
      return {
        ...state,
        sentSuccess: payload
      };
    default:
      return state;
  }
};

export default feedbackReducer;
